import Vue from "vue";
import VueRouter from "vue-router";

const Home = () => import("@/views/Home");
const HomePage = () => import("@/views/Home/HomePage");
const HomeNav = () => import("@/views/Home/HomeNav");
const LoginContainer = () => import("@/views/Login/Container");
const LoginWelcome = () => import("@/views/Login/Welcome");
const LoginForm = () => import("@/views/Login/LoginForm");
const RegisterFace = () => import("@/views/Login/RegisterFace");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "AppContainer",
    component: Home,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "MainPage",
        meta: { label: "Home" },
        redirect: "/home/ini",
        component: HomeNav,
        children: [
          {
            path: "ini",
            name: "MainPage",
            meta: { label: "Home" },
            component: HomePage,
          },
          {
            path: "chat",
            name: "about",
            component: () => import("../views/About.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: LoginContainer,
    redirect: "/login/welcome",
    children: [
      {
        path: "welcome",
        name: "LoginWelcome",
        component: LoginWelcome,
      },
      {
        path: "form",
        name: "LoginForm",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: LoginForm,
      },
      {
        path: "register",
        name: "RegisterForm",
        component: () => import("../views/Login/Register.vue"),
      },
      {
        path: "face",
        name: "RegisterFace",
        component: RegisterFace,
      },
    ],
  },

  {
    path: "/logoff",
    name: "logoff",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
  },
];

export const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

function validateUser(userstr) {
  if (userstr) {
    var user = JSON.parse(userstr);
    if (user) {
      var date1 = new Date(user.loginDate);
      var date2 = new Date();
      var diffTime = Math.abs(date2.getTime() - date1.getTime());
      var diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
      if (diffHours > 12) return null;
    }
    return user;
  }
  return null;
}

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login/welcome", "/login/form", "/login/face"];
  const authRequired = !publicPages.includes(to.path);
  if (!authRequired) {
    return next();
  } else {
    const loggedIn = validateUser(localStorage.getItem("user"));
    if (!loggedIn) {
      return next("/login/welcome");
    }
    next();
  }
});

export default router;
